// extracted by mini-css-extract-plugin
export default {"horizontal":"FeatureContainerRenderer_horizontal__W6NUP"};